import { Button } from '../../../../kendo-react-buttons';
/**
 * Represents the default `toggleButton` component rendered by the [KendoReact Scheduler DatePicker]({% slug overview_datepicker %}).
 */
export var ToggleButton = Button;
